import { ChevronDownIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import { resolvePluralsSteps } from "@/service/text/plurals";

export const PathContent = ({
  title,
  isPathHidden,
  totalSteps,
  isExpanded,
  showChevron = false,
}: {
  title: string;
  isPathHidden: boolean;
  totalSteps: number;
  isExpanded?: boolean;
  showChevron?: boolean;
}) => {
  return (
    <div className={cn("flex flex-1 flex-col")}>
      <div className="flex items-center justify-between">
        <div>
          <span
            className={cn(
              "text-[14px]",
              isExpanded ? "font-semibold text-black" : "text-zinc-600",
              isPathHidden && "text-black opacity-40",
            )}
          >
            {title}
          </span>
          {isPathHidden && (
            <Badge className="flex h-4 items-center justify-center rounded-full bg-zinc-500 px-1.5 text-xs font-medium text-white opacity-40">
              wkrótce
            </Badge>
          )}
        </div>
        {showChevron && (
          <ChevronDownIcon
            size={16}
            className={cn(
              "text-zinc-500 transition-transform",
              isExpanded && "rotate-180",
              isPathHidden && "hidden",
            )}
          />
        )}
      </div>
      <span
        className={cn("mt-0.5 text-xs text-zinc-400", isPathHidden && "hidden")}
      >
        {resolvePluralsSteps(totalSteps)}
      </span>
    </div>
  );
};
